import Pirates from "./containers/Pirates";
export default Pirates;
